import './App.css';
import './MediaQueries.css';

import {
  BrowserRouter,
  Routes,
  Route,
  useLocation
} from 'react-router-dom';

import ScrollToTop from './Components/ScrollToTop';
import Home from './Pages/Home';
import Header from './Components/Header';
import Footer from './Components/Footer';
import About from './Pages/About';
import Services from './Pages/Services';
import Contact from './Pages/Contact';
import PrivacyPolicy from './Pages/PrivacyPolicy';
import NotFound from './Pages/NotFound';
import Products from './Pages/Products';
import CustomisedProduct from './Pages/CustomisedProduct';
import WhatsAppButton from './Components/Whatsapp';
import Blog from './Pages/Blog';
import BlogDetail from './Pages/BlogDetail';
import Sitemap from './Pages/Sitemap';
import TermsConditions from './Pages/TermsConditions';
import ProductsCommon from './Pages/ProductsCommon';
import ProductsCommonGandhidham from './Pages/ProductsCommonGandhidham';
import CustomisedProductGandhidham from './Pages/CustomisedProductGandhidham';
import ProductsCommonMundra from './Pages/ProductsCommonMundra';
import CustomisedProductMundra from './Pages/CustomisedPrdouctMundra';

function AppContent() {

  const location = useLocation();

  return (
    <>
      <ScrollToTop />

      {/* HIDE WHATSAPP BUTTON ON HOME PAGE */}
      {location.pathname !== "/" && <WhatsAppButton />}

      <Header />

      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/about-us" element={<About />} />
        <Route path="/services" element={<Services />} />
        <Route path="/products" element={<ProductsCommon />} />
        <Route path="/products/:slug" element={<Products />} />
        <Route
          path="/products/customised-packaging"
          element={<CustomisedProduct />}
        />
        <Route path="/blog" element={<Blog />} />
        <Route path="/blog/:slug" element={<BlogDetail />} />
        <Route path="/contact-us" element={<Contact />} />
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
         <Route path="/terms-conditions" element={<TermsConditions />} />
        <Route path="/sitemap" element={<Sitemap/>} />
        <Route path="/*" element={<NotFound />} />
        <Route path="/products/gandhidham" element={<ProductsCommonGandhidham />} />
        <Route path="/products/customised-packaging-solution-in-gandhidham" element={<CustomisedProductGandhidham />} />
        <Route path="/products/mundra" element={<ProductsCommonMundra />} />
        <Route path="/products/customised-packaging-solution-in-mundra" element={<CustomisedProductMundra />} />
      </Routes>
      <Footer />
    </>
  );
}

function App() {

  return (
    <BrowserRouter>
      <AppContent />
    </BrowserRouter>
  );
}

export default App;